import React from 'react';

export const LoadingSkeleton: React.FC = () => (
	<div className="gpb-booking-time-picker__skeleton">
		{[...Array(8)].map((_, i) => (
			<div key={i} className="gpb-booking-time-picker__skeleton-slot" />
		))}
	</div>
);
